import { h } from "./dom";
import { icon } from "./icons";

export type Theme = "light" | "dark";

// Light is the recommended default; dark is an explicit, remembered opt-in. The
// key is supplied separately by the dashboard and preview and is unrelated to the dashboard token.
export function createTheme(THEME_KEY: string) {

  function getStoredTheme(): Theme {
    try {
      return localStorage.getItem(THEME_KEY) === "dark" ? "dark" : "light";
    } catch {
      return "light";
    }
  }

  function applyTheme(theme: Theme) {
    document.documentElement.dataset.theme = theme;
  }

  function setTheme(theme: Theme) {
    applyTheme(theme);
    try {
      localStorage.setItem(THEME_KEY, theme);
    } catch {
      // Storage can be blocked (private windows); the theme still applies for this page.
    }
  }

  function currentTheme(): Theme {
    return document.documentElement.dataset.theme === "dark" ? "dark" : "light";
  }

  /** A toggle button (aria-pressed) that switches between light and dark. */
  function themeToggle(): HTMLButtonElement {
    const btn = h("button", { type: "button", class: "cp-btn cp-btn--secondary cp-btn--sm", "aria-pressed": "false" });
    const paint = () => {
      const dark = currentTheme() === "dark";
      btn.setAttribute("aria-pressed", String(dark));
      btn.replaceChildren(icon(dark ? "moon" : "sun", 16), h("span", null, "Dark mode"));
    };
    btn.addEventListener("click", () => {
      setTheme(currentTheme() === "dark" ? "light" : "dark");
      paint();
    });
    paint();
    return btn;
  }

  return {getStoredTheme,applyTheme,setTheme,currentTheme,themeToggle};

}
